import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export interface Identidade {
  id: number;
  idPessoa: number;
  idCliente: number;
  nome: string;
  email: string;
  login: string | null;
  administrador: boolean;
  nomeCliente: string | null;
  /** Equipe T4i (conta Microsoft). Conta de cliente: false. */
  equipe?: boolean;
  /** O contrato que a equipe atende (09/10/2026); conta de cliente: 0. */
  idContrato?: number;
  nomeContrato?: string | null;
  /** Conta de cliente: sempre. Equipe: com a função no perfil do ProService. */
  abreChamados?: boolean;
}

/**
 * Quem está na sessão, lido do cadastro. O login guarda nome e cliente no
 * navegador por horas; isto os mantém em dia. Quando a pessoa ou o cliente
 * deixam de estar ativos a API responde 401, e o interceptor encerra a sessão.
 */
export const useIdentidade = (habilitado: boolean) =>
  useQuery({
    queryKey: ["identidade"],
    queryFn: async (): Promise<Identidade> => {
      const { data } = await api.get<Identidade>("/me");
      return data;
    },
    enabled: habilitado,
    staleTime: 5 * 60_000,
    retry: false,
  });

export interface TrocaDeSenha {
  senhaAtual: string;
  novaSenha: string;
}

/**
 * Troca a senha do usuário autenticado. A conta é resolvida pelo id do token,
 * não pelo login digitado, então não há como trocar a senha de outra pessoa.
 *
 * O token atual segue valendo até expirar: esta API não revoga sessão, e
 * invalidar as demais depois da troca é decisão registrada na spec.
 */
export const useTrocarSenha = () =>
  useMutation({
    mutationFn: async ({ senhaAtual, novaSenha }: TrocaDeSenha) => {
      await api.post("/me/senha", { senhaAtual, novaSenha });
    },
  });
